// TODO(Raj): Make this a noop on production builds.
export const logDebug = msg => console.log(msg);

// TODO(Raj): These should get to the log aggregator for real world.
export const logInfo = msg => console.log(msg);
export const logError = msg => console.error(msg);